export function easeOutQuad(x) {
  return 1 - (1 - x) * (1 - x)
}

export function easeInOutQuad(x) {
  return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2
}

export const lerp = (current, target, multiplier = 0.05) => {
  return (1 - multiplier) * current + multiplier * target
}
